import {
  ACTION_ARGS,
  COMPONENT_STATE_ARGS,
  INPUT_MENU_ARGS,
  MENU_ARGS,
  Metadata,
  pick,
} from '../../../../utils/spds/metadata';
import { eq } from 'ember-truth-helpers';
import { fn, hash } from '@ember/helper';
import Menu from './menu/base.gjs';
import NoResults from '../../core/menu/no-results.gjs';
import SearchMenuItem from './menu/item.gjs';
import Super from '../../core/menu/parent.gjs';
import boldMatchingText from '../../../../modifiers/bold-matching-text';

const Item = <template>
  <SearchMenuItem
    @onClick={{@onClick}}
    @registerComponent={{@registerComponent}}
    @retainSelection={{@retainSelection}}
    @unregisterComponent={{@unregisterComponent}}
    @value={{@value}}
    {{boldMatchingText @searchValue}}
    ...attributes
  >
    {{yield}}
  </SearchMenuItem>
</template>;

const METADATA = Metadata.define({
  description: 'Menu for displaying search results with selectable items',
  extends: [
    pick(MENU_ARGS, ['anchorElement']),
    pick(INPUT_MENU_ARGS, [{ name: 'displayedItemCount', required: true }, 'noResultsText']),
    pick(ACTION_ARGS, [{ name: 'onSelect', required: true }]),
    pick(COMPONENT_STATE_ARGS, [{ name: 'open', required: true }]),
  ],
  name: 'Search Menu',
});

export default class SpdsInputSearchMenu extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-input-search-menu';

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @id={{@id}}
      @open={{@open}}
      @noItemsDisplayed={{eq @displayedItemCount 0}}
      @noResultsText={{@noResultsText}}
      class="spds-input-search-menu"
      data-test-spds-input-search-menu
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          item=(component
            Item
            onClick=@onSelect
            registerComponent=(fn this.registerItem false)
            retainSelection=@retainSelection
            searchValue=@searchValue
            unregisterComponent=this.unregisterItem
          )
          noResults=(component NoResults)
        )
      }}
    </Menu>
  </template>
}

export const SEARCH_MENU_METADATA = SpdsInputSearchMenu.metadata;
